import SideNav from "./SideNav";
import TopBar from "./TopBar";
import React, { useState,  useEffect, useRef, useContext } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net';
import {Link, useParams, useNavigate} from "react-router-dom";
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import Swal from 'sweetalert2';
import moment from 'moment';
import UserContext from './UserContext';

function PendingBookings(){
    
    const API_URL = process.env.REACT_APP_API_URL;
    const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;

    const navigate = useNavigate();
    const tableRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [customer, setCustomer] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [payments, setPayments] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [perPage, setPerPage] = useState(25);
    const [error_list, setErrorList] = useState([]);
    const userContext = useContext(UserContext);
    const [email_template, setEmail_template] = useState([]);
    const PAYMENT_API_URL = process.env.REACT_APP_PAYMENT_URL;

    const [dateFrom, setDateFrom] = useState(""); // Start date
    const [dateTo, setDateTo] = useState(""); 
    const [filteredLocations, setFilteredLocations] = useState([]);
    const [selectedGameLocation, setSelectedGameLocation] = useState('');
    const [showDateFields, setShowDateFields] = useState(false);  
    const [game_available, setGame_available] = useState([]);
    const [selectedGame, setSelectedGame] = useState('');
    const [team, setTeam] = useState([]);    
    const API_BASE_URL = process.env.REACT_APP_BASE_URL;
    const [selectedStaff, setSelectedStaff] = useState(''); 


      const filteredResult = customer.filter((item) => {
        const matchesSearchQuery = `${item.firstname} ${item.lastname}`.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.booking_ref_id.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.phone.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.location_name.toLowerCase().includes(searchQuery.toLowerCase());


        const matchesLocation = selectedGameLocation === "all" || item.location_id === parseInt(selectedGameLocation);
        const matchesGame = selectedGame || item.game_id === parseInt(selectedGame) ;
        const matchesStaff = selectedStaff === "all" || 
  (item.staff && item.staff.split(",").map((id) => id.trim()).includes(String(selectedStaff)));

   
       // Check if booking date is within the selected date range
const matchesDate = (!dateFrom || item.booked_date >= dateFrom) &&
(!dateTo || item.booked_date <= dateTo);

return matchesSearchQuery && matchesLocation && matchesGame && matchesStaff && matchesDate;
 //&& matchesStatus;

       });


     
      const handlePageChange = (selectedPage) => {
        setCurrentPage(selectedPage.selected);
      };
      
      useEffect(() => {
        if (userContext.username) {
          setIsLoading(true);
          AOS.init({ duration: 1200 });
            getLocationByUser();
        }
      }, [userContext.username]); 
      


async function getLocationByUser() {

  axios.get(`${API_URL}/view-team-member-by-username-pending/${userContext.username}`).then(res => {
   if(res.data.status === 200){

    const filteredLocations = res.data.locations;

    setFilteredLocations(filteredLocations);  
    if (filteredLocations.length > 0) {
     const defaultLocation = filteredLocations[0].id;
     setSelectedGameLocation('all');
     fetchGameAvailable(defaultLocation); 
    }

       
    setSelectedStaff('all');

    const customer = res.data.bookings;
    setCustomer(customer);
    setCustomers(res.data.customers);
    setPayments(res.data.payments.filter(payment => payment.is_deleted === 0));
// console.log(res.data.bookings)
   }
   else if(res.data.status === 404){
       //setMessage(res.data.message);
       //console.log(res.data.status);
       }
       
   setIsLoading(false);
});
       
   
}


useEffect(() => {
  getTeamList();
  getEmailTemplateList();
}, []);

function getTeamList()
  {    
   
  axios.get(`${API_URL}/view-team-members`).then(res=>{
        if(res.data.status === 200){
            setTeam(res.data.team);    
        }     
        else if(res.data.status === 404){
          setTeam([]);
           // setMessage(res.data.message);     
            }             
     });    
  }

   function getEmailTemplateList()
      {    
        axios.get(`${API_URL}/view-email-template`).then(res=>{
            if(res.data.status === 200){
                setEmail_template(res.data.emailTemplate);       
            }     
            else if(res.data.status === 404){
              setEmail_template([]);
               // setMessage(res.data.message);     
                }             
         });    
      }

const handleGameAvailableLocationChange = (e) => {
  const selectedGameLocationId = e.target.value;
  setSelectedGameLocation(selectedGameLocationId);
 
  if(selectedGameLocationId == "all")
  {
      const locationIds = filteredLocations.map(location => location.id);
      fetchAllLocationGameAvailable(locationIds);
  }
  else{
      fetchGameAvailable(selectedGameLocationId);
  }
};


async  function fetchGameAvailable(locationId) {
        // setIsLoading(true); // Start loader for game fetching
         axios.get(`${API_URL}/view-available-game-by-locationId/${locationId}`)
             .then(res => {
                 if (res.data.games) {
                     setGame_available(res.data.games);
                     if (res.data.games.length > 0) {
                         setSelectedGame(res.data.games[0].id);
                     } else {
                         setSelectedGame('');
                     }
                 } else {
                     setGame_available([]);
                 }
             })
             .catch(error => {
                 console.error("Error fetching games:", error);
             })
             .finally(() => {
                setIsLoading(false); // Now that both data (location and games) have loaded, stop main loader
              });
     }




function fetchAllLocationGameAvailable(locationIds) {
  // setIsLoading(true); // Start loader for game fetching
  const locationIdsString = locationIds.join(','); // Convert array to comma-separated string

  axios.get(`${API_URL}/view-available-game-by-locationIds/${locationIdsString}`)
      .then(res => {
          if (res.data.games) {
              setGame_available(res.data.games);
              if (res.data.games.length > 0) {
                  setSelectedGame(res.data.games[0].id);
              } else {
                  setSelectedGame('');
              }
          } else {
              setGame_available([]);
          }
          // setIsLoading(false); // Stop loader for game fetching
      })
      .catch(error => {
          console.error("Error fetching games:", error);
          // setIsLoading(false); // Stop loader for game fetching
      });
}



    const formatBookedTime = (bookedTime) => {
        try {
          const timeSlots = JSON.parse(bookedTime); // Assuming bookedTime is a JSON string
          if (Array.isArray(timeSlots) && timeSlots.length > 0) {
            
            // Sort time slots by start time before merging
            const sortedSlots = timeSlots.sort((a, b) => {
              const [startA] = a.split(' - ');
              const [startB] = b.split(' - ');
              return moment(startA, 'hh:mm A').diff(moment(startB, 'hh:mm A'));
            });
      
            let mergedSlots = [];
            let currentRangeStart = null;
            let currentRangeEnd = null;
      
            sortedSlots.forEach((slot, index) => {
              const [startTime, endTime] = slot.split(' - ');
              const currentStartTime = moment(startTime, 'hh:mm A');
              const currentEndTime = moment(endTime, 'hh:mm A');
      
              if (!currentRangeStart) {
                // First time slot, initialize the range
                currentRangeStart = currentStartTime;
                currentRangeEnd = currentEndTime;
              } else if (currentRangeEnd.isSame(currentStartTime)) {
                // If the current slot starts when the last one ended, extend the range
                currentRangeEnd = currentEndTime;
              } else {
                // If the current slot does not continue from the last one, close the current range and start a new one
                mergedSlots.push(`${currentRangeStart.format('h:mm A')} - ${currentRangeEnd.format('h:mm A')}`);
                currentRangeStart = currentStartTime;
                currentRangeEnd = currentEndTime;
              }
      
              // If it's the last slot, push the current range
              if (index === sortedSlots.length - 1) {
                mergedSlots.push(`${currentRangeStart.format('h:mm A')} - ${currentRangeEnd.format('h:mm A')}`);
              }
            });
      
            return mergedSlots.join(', '); // Join the merged slots with a comma
          }
          return 'No time slots available';
        } catch (error) {
          console.error("Error parsing booked time:", error);
          return 'Invalid time format';
        }
      };

      function convertPlainTextToHTML(text) {
        return text
            .replace(/\n/g, '<br>')  // Replace line breaks with <br>
            .replace(/ {2,}/g, match => '&nbsp;'.repeat(match.length));  // Replace multiple spaces with &nbsp;
    }


    // const approveBooking = async (id) => {
    //   const buttonClicked = window.confirm("Are you sure you want to approve this booking?");
    //   if (!buttonClicked) {
    //     getLocationByUser(); 
    //     return;
    //   }
    
      
    //   try {
    //     setIsLoading(true);
    //     const res = await axios.put(`${API_URL}/approve-booked-slot/` + id, {
    //       booking_completed: 1,
    //       updated_by: userContext.userDetails.id,
    //       booked_date: customer[0].booked_date,
    //       booked_time: customer[0].booked_time,
    //       no_of_adults: customer[0].no_of_adults,
    //       no_of_children: customer[0].no_of_children,
    //     });
    
    //     const data = customer.find(item => item.id === id);
    //     const customer_id = customers.find(item => item.booking_id === id).id;
    //     const emailData = prepareApproveEmailData(data);
    
       
    
    //     const customerById = data;
    //     const customerFirstName = customerById.firstname || "Customer";
    //     const generatePaymentAmount = customer[0].deposit_amt;
    //     const reason = "Deposit Amount";
    //     const note = "";
    
    //     const formData = new FormData();
    //     formData.append("booking_id", customerById.booking_id);
    //     formData.append("customer_id", customer_id);
    //     formData.append("requested_amt", generatePaymentAmount);
    //     formData.append("total_due", customerById.grand_total?.toFixed(2) || "0.00");
    //     formData.append("reason", reason);
    //     formData.append("note", note);
    
    //     const headers = {
    //       Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
    //     };
    
    //     const paymentRes = await axios.post(`${API_URL}/generate-payment-link`, formData, { headers });
    //     const paymentId = paymentRes.data.payment_link?.payment_id;
    
    //     if (paymentId) {
    //       const paymentLink = `${PAYMENT_API_URL}/${paymentId}`;
    //       const PaymentTemplate = email_template.find(item => item.template_name === 'Payment Link');
    
    //       let updatedMessage = PaymentTemplate.message
    //         .replace(/\[customer_name\]/g, customerFirstName)
    //         .replace(/\[payment_link\]/g, paymentLink)
    //         .replace(/\[amount\]/g, generatePaymentAmount);
    
    //       if (reason) {
    //         updatedMessage = updatedMessage.replace("[reason]", reason);
    //       } else {
    //         updatedMessage = updatedMessage.replace(/.*Reason\s*:\s*\[reason\]\s*\n?/gi, "");
    //       }
    
    //       if (note) {
    //         updatedMessage = updatedMessage.replace("[note]", note);
    //       } else {
    //         updatedMessage = updatedMessage.replace(/.*Note\s*:\s*\[note\]\s*\n?/gi, "");
    //       }


    //        await axios.post(`${API_URL}/send-email`, emailData);
    
    //       // const emailFormData = new FormData();
    //       // emailFormData.append("booking_id", customerById.booking_id);
    //       // emailFormData.append("customer_id", customer_id);
    //       // emailFormData.append("to", customerById.email);
    //       // emailFormData.append("subject", PaymentTemplate.subject);
    //       // emailFormData.append("message", convertPlainTextToHTML(updatedMessage));
    
    //       // await axios.post(`${API_URL}/send-email-invoice`, emailFormData, { headers });
    //     }
    
    //      Swal.fire({
    //       icon: "success",
    //       text: res.data.message
    //     });
    
    //     getLocationByUser(); // refresh after Swal is dismissed
    //   } catch (error) {
    //     console.error("Error approve booking:", error);
    //   } finally {
    //     setIsLoading(false); // this guarantees the loader is hidden
    //   }
    // };
    

const approveBooking = async (id) => {
  const buttonClicked = window.confirm("Are you sure you want to approve this booking?");
  if (!buttonClicked) {
    getLocationByUser(); 
    return;
  }

  try {
    setIsLoading(true);

    // Step 1: Approve the booking in the backend
    const res = await axios.put(`${API_URL}/approve-booked-slot/` + id, {
      booking_completed: 1,
      updated_by: userContext.userDetails.id,
      booked_date: customer[0].booked_date,
      booked_time: customer[0].booked_time,
      no_of_adults: customer[0].no_of_adults,
      no_of_children: customer[0].no_of_children,
    });

    // Step 2: Get customer and booking data
    const data = customer.find(item => item.id === id);
    const customer_id = customers.find(item => item.booking_id === id).id;
    const customerFirstName = data.firstname || "Customer";
    const generatePaymentAmount = customer[0].deposit_amt;
    const reason = "Deposit Amount";



    // Step 3: Generate payment link
    const formData = new FormData();
    formData.append("booking_id", data.booking_id);
    formData.append("customer_id", customer_id);
    formData.append("requested_amt", generatePaymentAmount);
    formData.append("total_due", data.grand_total?.toFixed(2) || "0.00");
    formData.append("reason", reason);

    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
    };

    const paymentRes = await axios.post(`${API_URL}/generate-payment-link`, formData, { headers });
    const paymentId = paymentRes.data.payment_link?.payment_id;

    if (paymentId) {
      const paymentLink = `${PAYMENT_API_URL}/${paymentId}`;
      const CombinedTemplate = email_template.find(item => item.template_name === 'Booking Confirmation Same Day');

      const formattedBookedTime = formatBookedTime(data.booked_time);
      const consentFormUrl = `${API_BASE_URL}/consent-form-page/${data.booking_ref_id}/${data.booking_id}`;
      const qrCodeUrl = `${LARAVEL_API_URL}/uploads/qrImages/${data.booking_ref_id}.png`;
      const packageName = data.game_type_name || 
        (data.package_name === 'Corporate' 
          ? `${data.package_name} - ${data.corporate_package_name}`
          : `${data.package_name} - ${data.game_package_name}`);

      let message = CombinedTemplate.message
        .replace(/\[customer_name\]/g, `${data.firstname} ${data.lastname}`)
        .replace(/\[event_date\]/g, moment(data.booked_date).format('D MMMM YYYY'))
        .replace(/\[event_time\]/g, formattedBookedTime)
        .replace(/\[location\]/g, data.location_name)
        .replace(/\[number_of_players\]/g, data.total_players)
        .replace(/\[package_name\]/g, packageName)
        .replace(/\[payment_link\]/g, `<a href="${paymentLink}">${paymentLink}</a>`)
        .replace(/\[amount\]/g, generatePaymentAmount)
        .replace(/\[reason\]/g, reason || "")
        .replace(/\[consent_form_link\]/g, `<a href="${consentFormUrl}">Click here to complete the consent form</a>`)
        .replace(/\[qr_code\]/g, `<img src="${qrCodeUrl}" alt="QR Code for Consent Form" />`);

      // Step 4: Send email with full booking + payment info
      const emailFormData = new FormData();
      emailFormData.append("booking_id", data.booking_id);
      emailFormData.append("customer_id", customer_id);
      emailFormData.append("to", data.email);
      emailFormData.append("subject", CombinedTemplate.subject);
      emailFormData.append("message", convertPlainTextToHTML(message));

      await axios.post(`${API_URL}/send-email-invoice`, emailFormData, { headers });

      Swal.fire({
        icon: "success",
        text: res.data.message,
      });

      getLocationByUser();
    }
  } catch (error) {
    console.error("Error approving booking:", error);
  } finally {
    setIsLoading(false);
  }
};


    

    const cancelBooking = (e, id) => {
      e.preventDefault();
      
      var buttonClicked = window.confirm("Are you sure you want to cancel this booking?");
      
      if (buttonClicked === true) {

        const cancelReason = window.prompt("Enter the reason for cancellation (optional):");

        // var sendNotification = window.confirm("Do you want to send a cancellation notification email?");
     
         axios.put(`${API_URL}/cancel-booked-slot/` + id, {
              booking_completed: 0 ,
              updated_by: userContext.userDetails.id,
              booked_date: customer[0].booked_date,       // Add booked_date if needed
              booked_time: customer[0].booked_time,       // Add booked_time if needed
              no_of_adults: customer[0].no_of_adults,              // Add no_of_adults
              no_of_children: customer[0].no_of_children,
              cancel_reason: cancelReason || null,   
        
          }).then(res => {
            // if (sendNotification === true) {
            const data = customer.find(item=>item.id === id)
            const emailData =  prepareCancelEmailData(data, cancelReason);
            // API call to send email
            const emailResponse =  axios.post(`${API_URL}/send-email`, emailData);
            // }
             
              Swal.fire({
                  icon: "success",
                  text: res.data.message
              }).then(function() {
               // setIsLoading(true);
                  // Optionally update UI after booking is cancelled
                  getLocationByUser(); 
              });
          
          }).catch(error => {
              // Handle any errors here
            //   Swal.fire({
            //   text:error.response.data.message,
            //   icon:"error"
            // })
            setIsLoading(false);
              console.error("Error canceling booking:", error);
          });
      } else {
        setIsLoading(false);
          getLocationByUser();
      }
  }

  function prepareCancelEmailData(bookingDetails, cancelReason) {

    const CancelTemplate = email_template.find(item => item.template_name === 'Booking Cancellation Same Day');
 

    const formattedBookedTime = formatBookedTime(bookingDetails.booked_time);
    // Convert the plain text template to HTML
    const message = convertPlainTextToHTML(CancelTemplate.message)
        .replace('[customer_name]', `${bookingDetails.firstname} ${bookingDetails.lastname}`)
        .replace('[event_date]', moment(bookingDetails.booked_date).format('D MMMM YYYY'))
        .replace('[event_time]', formattedBookedTime)  // Joining the times array into a string
        .replace('[location]', bookingDetails.location_name)
        .replace('[number_of_players]', bookingDetails.total_players)
        .replace('[cancel_reason]', cancelReason)
        .replace('[package_name]',
          bookingDetails.game_type_name ||
          (bookingDetails.package_name === 'Corporate' 
            ? `${bookingDetails.package_name} - ${bookingDetails.corporate_package_name}`
            : `${bookingDetails.package_name} - ${bookingDetails.game_package_name}`
          ))
          //bookingDetails.game_type_name || `${bookingDetails.package_name} - ${bookingDetails.game_package_name}`)
      
    return {
        booking_id: bookingDetails.booking_id,
        to: bookingDetails.email,
        subject: CancelTemplate.subject,
        message, // This is now HTML formatted
        bcc: 'booking.lasercombat@hotmail.com', 
    };
}



   function prepareApproveEmailData(bookingDetails) {

    const ApproveTemplate = email_template.find(item => item.template_name === 'Booking Confirmation Same Day');
 

    const formattedBookedTime = formatBookedTime(bookingDetails.booked_time);
    // Convert the plain text template to HTML
    const consentFormUrl = `${API_BASE_URL}/consent-form-page/${bookingDetails.booking_ref_id}/${bookingDetails.booking_id}`;
   
    const message = convertPlainTextToHTML(ApproveTemplate.message)
        .replace('[customer_name]', `${bookingDetails.firstname} ${bookingDetails.lastname}`)
        .replace('[event_date]', moment(bookingDetails.booked_date).format('D MMMM YYYY'))
        .replace('[event_time]', formattedBookedTime)  // Joining the times array into a string
        .replace('[location]', bookingDetails.location_name)
        .replace('[number_of_players]', bookingDetails.total_players)
        .replace('[package_name]',
          bookingDetails.game_type_name ||
          (bookingDetails.package_name === 'Corporate' 
            ? `${bookingDetails.package_name} - ${bookingDetails.corporate_package_name}`
            : `${bookingDetails.package_name} - ${bookingDetails.game_package_name}`
          ))
          //bookingDetails.game_type_name || `${bookingDetails.package_name} - ${bookingDetails.game_package_name}`)
          .replace('[consent_form_link]', `<a href="${consentFormUrl}">Click here to complete the consent form</a>`)
          .replace('[qr_code]', `<img src="${LARAVEL_API_URL}/uploads/qrImages/${bookingDetails.booking_ref_id}.png" alt="QR Code for Consent Form" />`);

    return {
        booking_id: bookingDetails.booking_id,
        to: bookingDetails.email,
        subject: ApproveTemplate.subject,
        message, // This is now HTML formatted
        bcc: 'booking.lasercombat@hotmail.com', 
    };
}


const handleDateFromChange = (e) => {
  setDateFrom(e.target.value);
};

const handleDateToChange = (e) => {
  setDateTo(e.target.value);
};


const formatDateLocal = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};


const handleDateOptionChange = (event) => {
  const value = event.target.value;
  const today = new Date();

  switch (value) {
    case "today":
      setDateFrom(formatDateLocal(today));
      setDateTo(formatDateLocal(today));
      setShowDateFields(false);
      break;

    case "yesterday":
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      setDateFrom(formatDateLocal(yesterday));
      setDateTo(formatDateLocal(yesterday));
      setShowDateFields(false);
      break;

    case "this_week":
      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - today.getDay()); // Sunday
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6); // Saturday
      setDateFrom(formatDateLocal(startOfWeek));
      setDateTo(formatDateLocal(endOfWeek));
      setShowDateFields(false);
      break;

    case "last_week":
      const lastWeekStart = new Date(today);
      lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Last week's Sunday
      const lastWeekEnd = new Date(lastWeekStart);
      lastWeekEnd.setDate(lastWeekStart.getDate() + 6); // Last week's Saturday
      setDateFrom(formatDateLocal(lastWeekStart));
      setDateTo(formatDateLocal(lastWeekEnd));
      setShowDateFields(false);
      break;

    case "this_month":
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      setDateFrom(formatDateLocal(firstDayOfMonth));
      setDateTo(formatDateLocal(lastDayOfMonth));
      setShowDateFields(false);
      break;

    case "last_month":
      const lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1);
      const firstDayOfLastMonth = new Date(lastMonth.getFullYear(), lastMonth.getMonth(), 1);
      const lastDayOfLastMonth = new Date(lastMonth.getFullYear(), lastMonth.getMonth() + 1, 0);
      setDateFrom(formatDateLocal(firstDayOfLastMonth));
      setDateTo(formatDateLocal(lastDayOfLastMonth));
      setShowDateFields(false);
      break;

    case "this_year":
      const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
      const lastDayOfYear = new Date(today.getFullYear(), 11, 31);
      setDateFrom(formatDateLocal(firstDayOfYear));
      setDateTo(formatDateLocal(lastDayOfYear));
      setShowDateFields(false);
      break;

    case "last_year":
      const lastYear = today.getFullYear() - 1;
      const firstDayOfLastYear = new Date(lastYear, 0, 1);
      const lastDayOfLastYear = new Date(lastYear, 11, 31);
      setDateFrom(formatDateLocal(firstDayOfLastYear));
      setDateTo(formatDateLocal(lastDayOfLastYear));
      setShowDateFields(false);
      break;

    case "custom":
      setShowDateFields(true);
      setDateFrom('');
      setDateTo('');
      break;

    default:
      setDateFrom('');
      setDateTo('');
      setShowDateFields(false);
  }
};


    return(
        <div>
<SideNav/>
      <TopBar/>

      {isLoading?
     <div className="loader-container" style ={{backgroundColor: "rgba(0, 0, 0, 0.5)", position: "fixed",top: "0",left: "0",width: "100%",height: "100%",display: "flex",justifyContent: "center",alignItems: "center",zIndex: "9999"}}>
    <div class="d-flex justify-content-center">
  <div class="spinner-border" role="status">
  </div>
  </div>
</div>:null}
      <div class="right_panel position contact_section vh-100" id="right_panel">

        <div class="main_title" data-aos="fade-down" data-aos-delay="" data-aos-duration="1200">
            <h1><i class="bi bi-book"></i> Pending Bookings</h1>
           
         
        </div>



        <div class="content_wrapper pt-0" data-aos-delay="" data-aos-duration="1200">
        <div class="vm_content_box_1">
        <div class="content pt-1">
                <div class=" pt-1 pb-1">
                <div class="row ">

              
                <div class="content col-md-2">
                                <div class="form-group pt-2 pb-2">
                                    <label>Location</label>
                                    <select class="form-select" id="selectedGameLocation" name="selectedGameLocation" value={selectedGameLocation} onChange={handleGameAvailableLocationChange}>
                                        <option value="">Select game location</option>
                                        <option value="all">All</option>
                                        {filteredLocations.map((location) => (
                                            <option key={location.id} value={location.id}>
                                                {location.location_name}
                                            </option>
                                        ))}
                                    </select>   {!selectedGameLocation && (
                                        <span class="text-danger">{error_list.location_id}</span>)}
                                </div>
                            </div>


                            {/* <div className="content col-md-2">
                <div className="form-group pt-2 pb-2">
                    <label>Date Options</label>
                    <select className="form-select" id="dateOptions" onChange={handleDateOptionChange}>
                        <option value="">Select date filter</option>
                        <option value="today">Today</option>
                        <option value="yesterday">Yesterday</option>
                        <option value="this_week">This Week</option>
                        <option value="last_week">Last Week</option>
                        <option value="this_month">This Month</option>
                        <option value="last_month">Last Month</option>
                        <option value="this_year">This Year</option>
                        <option value="last_year">Last Year</option>
                        <option value="custom">Custom</option>
                    </select>
                </div>
            </div>          */}

            {showDateFields && (
                <>
                            <div class="content col-md-2">
    <div class="form-group pt-2 pb-2">
        <label>Date From</label>
        <input
            type="date"
            className="form-control"
            id="dateFrom"
            name="dateFrom"
            value={dateFrom}
            onChange={handleDateFromChange}
        />
    </div>
</div>

<div class="content col-md-2">
    <div class="form-group pt-2 pb-2">
        <label>Date To</label>
        <input
            type="date"
            className="form-control"
            id="dateTo"
            name="dateTo"
            value={dateTo}
            onChange={handleDateToChange}
        />
    </div>
</div>
</>
            )}
              

                    </div>
                  
                    </div>
                    </div>
                    </div>
                    </div>

        <div class="content_wrapper pt-0" data-aos="fade-down" data-aos-delay="" data-aos-duration="1200">
            
            <div>
                <div class="vm_content_box_1">
                    <div class="content">

                    <div class="row pt-3">
                          
                          <div class="col-md-9 form-group" >
                                  <div class="d-flex input_wrapper">
                                  <div><label>Show   <select name="example_length" aria-controls="example" value={perPage} onChange={(e) => {setCurrentPage(0);setPerPage(Number(e.target.value))}}>
                                      <option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option>
                                    </select>  entries</label>
                                    </div>
                                  </div>
                              </div>
  
                              <div class="col-md-3 form-group">
                                  <div class="d-flex input_wrapper">
                                      <div class="icon_wrapper">
                                          <i class="bi bi-search icon"></i>
                                      </div>
                                      <input class="form-control" name="searchQuery" id="searchQuery" placeholder="Search..." type="text" 
                                      value={searchQuery} onChange={(e) => {setSearchQuery(e.target.value)}}/>
                                  </div>
                              </div>
                          </div>
                          <div class="table-responsive">
                        <table class="display inventory_table_list dataTable dtr-inline" style={{width:"100%"}}>
                            <thead>
                                <tr>
                                    <th>Booking Id</th>
                                    <th>Customer Name</th>
                                    <th>Booked Date</th>
                                    <th>Booked Time</th>
                                    <th>Game Package</th>
                                    <th>Adults</th>
                                    <th>Kids</th>
                                    <th>Total Amt</th>
                                    <th>Location</th>
                                    <th>Booked On</th>
                                    <th  class="text-end">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {filteredResult.length === 0 ? (
        <tr>
          <td colSpan="4" style={{ textAlign: "center", verticalAlign: "middle" }}>
            <p className="odd" style={{ margin: 0 }}>No records found</p>
          </td>
        </tr>
      ) : (
                            filteredResult.slice((currentPage * perPage), ((currentPage * perPage) + perPage)).map((item, index) => {
                                           
                              const totalPaid = payments
                              .filter(pay => pay.booking_id === item.id)   // Filter payments for this booking
                              .reduce((sum, pay) => sum + Number(pay.payment_amount), 0); // Sum amounts
                             
                              const formattedTotalPaid = totalPaid.toFixed(2); // Format total paid to 2 decimals
                              const dueAmount = (
                                ((item.grand_total || 0) + (item.adjusted_total || 0)) - totalPaid
                              ).toFixed(2);

                              const grandTotal =   ((item.grand_total || 0) + (item.adjusted_total || 0)).toFixed(2);
 
                              return (
                                <tr key={item.id}>
                              
                                   <td style={{ verticalAlign: 'middle'}}>{item.booking_ref_id}</td>
                                    <td style={{ verticalAlign: 'middle'}}>{item.firstname} {item.lastname}</td>
                                    <td style={{ verticalAlign: 'middle', whiteSpace: 'nowrap'}}>{moment(item.booked_date).format('DD-MMM-YY')}</td>
                                    <td style={{ verticalAlign: 'middle', whiteSpace: 'nowrap' }}>{formatBookedTime(item.booked_time)}</td>
                                    <td style={{ verticalAlign: 'middle', whiteSpace: 'nowrap'}}>
                                    {item.game_type_name || (item.package_name === 'Corporate' 
                                    ? `${item.package_name} - ${item.corporate_package_name}`
                                   : `${item.package_name} - ${item.game_package_name}`
                                    )} </td>
                                  <td style={{ verticalAlign: 'middle'}}>{item.no_of_adults}</td>
                                    <td style={{ verticalAlign: 'middle'}}>{item.no_of_children}</td>
                                     
                                    <td style={{ verticalAlign: 'middle'}}>{grandTotal}</td>
                                    <td style={{ verticalAlign: 'middle'}}>{item.location_name}</td>
                                    <td style={{ verticalAlign: 'middle'}}>{moment(item.created_at).format('DD-MMM-YY, h:mm A')}</td>
                                    <td >
                                        <div class="d-flex justify-content-md-end" style={{margin:"7px 0px 0px 0px" }}>
                                        {/* <button class="btn btn-sm btn_secondary"  onClick={() => handleViewBookings(item.id)} style={{ background: "orange", color: "white", margin: "0px 10px 0px 0px"}} >
                                        <i class="bi bi-eye"></i></button> */}
                                   
                                              {/* View Button - Opens in New Tab */}
    

    <button
      className="btn btn-sm btn-success"
      style={{ marginLeft: "10px" }}
      onClick={() => approveBooking(item.id)}
    >
      <i className="bi-check-circle"></i> Approve
    </button>
                                            <button class="btn btn-sm btn_secondary" data-bs-target="#createNewCustomre" style={{ background: "red", margin: "0px 0px 0px 10px" }}
                                     onClick={(e) => cancelBooking(e, item.id)}><i class="bi-x-circle"></i> Cancel</button>
                             
                             {/* <a href={`/booking-details/${item.id}`} target="_blank" rel="noopener noreferrer" class="btn btn-sm btn_secondary" 
       style={{ background: "orange",  marginLeft: "10px", color: "white"}}>
      <i class="bi bi-eye"></i>
    </a>   */}
                             
                               </div>
                                    </td>
                                </tr> 
                             
)}))}
                            </tbody>
                            <tfoot style={{ borderTop: "1px solid #dee2e6", height: "1px" }}>
    <tr>
        <td colSpan="16" style={{ padding: 0, margin: 0, height: "1px" }}></td>
    </tr>
</tfoot>
                       
                        </table>
                        </div>
                        <div class="col-md-3" style={{ float: "left", padding: "20px 0px 0px 0px" }}>
                                        {filteredResult.length > 0 && `Showing 1 to ${Math.min(perPage, filteredResult.length)} of ${filteredResult.length} entries`}
                                    </div><div class="col-md-9" style={{ float: "right" }}>

                                        <ReactPaginate style={{ float: "right" }}
                                            previousLabel={"< Prev"}
                                            nextLabel={"Next >"}
                                            breakLabel={'...'}
                                            pageCount={Math.ceil(filteredResult.length / perPage)}
                                            onPageChange={handlePageChange}
                                            containerClassName={"pagination pagination-sm justify-content-center custom-pagination"} // Bootstrap pagination class
                                            disabledClassName={"disabled"}
                                            breakClassName={['page-item']}
                                            breakLinkClassName={'page-link'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item'}
                                            nextLinkClassName={'page-link'}
                                            activeClassName={['active']} />


                                    </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        </div>   
    );
}
export default PendingBookings;
